<template>
  <div class="page flex-col justify-between">
    <StudentHeader
      title="Python编程区"
      back-visibility="hidden"
    />

    <div class="group_4 flex-col">
      <div class="text-wrapper_3 flex-row">
        <span
          class="text_8"
          v-if="rightSidebar"
          >输出</span
        >
      </div>

      <div class="block_1 flex-row justify-between">
        <div class="box_1_hidden"></div>
        <!-- <div 
          class="resize-handle"
          @mousedown="startResize"
        ></div> -->

        <!-- 代码编辑区 -->
        <div
          class="box_14 flex-col"
          :style="{ width: getWidth() }"
        >
          <!-- menu -->
          <div class="block_7 flex-row justify-between">
            <img
              class="label_16"
              referrerpolicy="no-referrer"
              src="../../assets/student/coursetask/FigmaDDSSlicePNG9f9bde9ad6084f7e9bb68101e512fd7b.png"
            />
            <span class="text_37">Python编程</span>
          </div>

          <div class="group_9 flex-col"></div>
          <div class="editor">
            <MonacoEditor
              ref="monacoEditor"
              :code="code"
              :options="editorOptions"
            />
          </div>
          <div class="text-wrapper_9 flex-row">
            <div
              class="text-wrapper_10 flex-col"
              @click="runPython"
            >
              <span class="text_35">执行</span>
            </div>
            <div class="text-wrapper_11 flex-col">
              <span class="text_36">{{ message }}</span>
            </div>
          </div>
        </div>

        <!-- 右侧输出 -->
        <div
          class="box_15 flex-col"
          v-show="rightSidebar"
        >
          <pre
            id="output"
            class="py_result"
            >{{ result }}</pre
          >
        </div>
        <div
          class="box_15_hidden"
          v-if="!rightSidebar"
        ></div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="group_3 flex-row">
      <img
        class="label_8"
        @click="toggleRightSidebar"
        referrerpolicy="no-referrer"
        :src="
          rightSidebar === true
            ? require('../../assets/student/coursetask/FigmaDDSSlicePNG4e6efcf9741b61da2f4fa3aa71bcd17e.png')
            : require('../../assets/student/coursetask/FigmaDDSSlicePNG2ba541325ea2add7335ba9ad2fb442cb.png')
        "
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import MonacoEditor from "vue-monaco-editor"

import StudentHeader from "@/components/StudentHeader.vue"

const code = ref("")
const editorOptions = ref({
  minimap: {
    enabled: false,
  },
  lineNumbers: "on",
  fontSize: 20,
  automaticLayout: true,
  language: "python",
  glyphMargin: false,
  lineNumbersMinChars: 2,
  contextmenu: false,
  quickSuggestions: false,
  parameterHints: false,
  suggestOnTriggerCharacters: false,
})

// 初始化为空，等待接口填充
const message = ref("")
const result = ref("")
const monacoEditor = ref(null)
const rightSidebar = ref(true)

const toggleRightSidebar = () => {
  rightSidebar.value = !rightSidebar.value
}

// 组件挂载时初始化数据
onMounted(async () => {
  if (typeof brython === "function") {
    brython()
  }
})

const runPython = () => {
  const pythonCode = monacoEditor.value?.editor?.getValue() || ""
  if (!pythonCode) {
    message.value = "错误：请输入Python代码后再执行"
    return
  }

  const codeInput = document.getElementById("python-code")
  const runButton = document.getElementById("run-button")
  const outputElement = document.getElementById("output")

  if (!codeInput) {
    message.value = "错误：未找到代码输入元素"
    return
  }
  if (!runButton) {
    message.value = "错误：未找到运行按钮"
    return
  }
  if (!outputElement) {
    message.value = "错误：未找到输出元素"
    return
  }

  // 清空之前的输出和错误
  outputElement.textContent = ""
  message.value = "执行中..."

  codeInput.value = pythonCode
  runButton.click()

  // 使用setTimeout处理异步执行结果
  setTimeout(() => {
    const output = outputElement.textContent || ""
    // console.log('Brython执行输出:', output)
    // 增强错误模式匹配
    const errorPatterns = [
      /Traceback \(most recent call last\):/,
      /Error:/,
      /BrythonError:/,
      /SyntaxError:/,
    ]
    const hasError = errorPatterns.some((pattern) => pattern.test(output))

    if (hasError) {
      // 提取错误信息（取前200字符）
      const errorMsg =
        output.length > 200 ? output.substring(0, 200) + "..." : output
      message.value = `执行失败：${errorMsg}`
    } else if (output) {
      message.value = "执行成功！"
    } else {
      message.value = "执行失败：未获取到输出结果，请检查代码是否正确"
    }
    result.value = output
  }, 500)
}

const getWidth = () => {
  if (rightSidebar.value) {
    return "calc(100% - 24.65vw)"
  } else {
    return "calc(100% - 5.74vw)"
  }
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(30, 30, 30, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.group_1 {
  background-color: rgba(34, 76, 123, 1);
  width: 100vw;
  height: 2.87vw;
}

.group_4 {
  position: absolute;
  left: 0;
  top: 2.87vw;
  width: 100vw;
  height: calc(100% - 5.74vw);
  margin: 0;
}

.label_1 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.4vw 0 0 0.46vw;
  cursor: pointer;
}

.label_2 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.3vw 0 0 0.35vw;
}

.text_1 {
  width: 7.5vw;
  height: 2.4vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.4vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.88vw;
  margin: 0.4vw 0 0 0.81vw;
}

.text-wrapper_0 {
  position: absolute;
  width: 60vw;
  height: 2.87vw;
  margin: 0;
  top: 0;
  left: 20vw;
}

.text-wrapper_1 {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 8px;
  height: 1.72vw;
  width: 3.96vw;
  margin: 0.6vw 0 0 0;
}

.text_2 {
  width: 3.96vw;
  height: 1.72vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.35vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.72vw;
  margin: 0.03vw 0 0 0;
}

.text_3 {
  width: 4.33vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.5vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.6vw 0 0 0.5vw;
}

.label_3 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.44vw 0 0 0.6vw;
}

.label_12 {
  position: relative;
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.44vw 0 0 0.57vw;
}

.group_2 {
  background-color: rgba(104, 162, 250, 1);
  border-radius: 20px;
  width: 1.05vw;
  height: 1.05vw;
  margin: 0.9vw 0 0 0.53vw;
}

.group_idx {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 8px;
  height: 2.09vw;
  width: 2.09vw;
  margin: 0.44vw 0 0 0.63vw;
}

.text-wrapper_2 {
  background-color: rgba(243, 171, 69, 1);
  border-radius: 8px;
  height: 2.09vw;
  width: 2.09vw;
  margin: 0.44vw 0 0 0.93vw;
}

.text_4 {
  width: 0.99vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.66vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.2vw 0 0 0.57vw;
}

.label_4 {
  width: 2vw;
  height: 2vw;
  margin: 0.45vw 2.03vw 0 83.5vw;
  cursor: pointer;
}

.group_3 {
  background-color: rgba(45, 46, 62, 1);
  position: fixed;
  width: 100vw;
  height: 2.87vw;
  bottom: 0;
}

.label_5 {
  position: absolute;
  width: 1.67vw;
  height: 1.67vw;
  top: 0.6vw;
  left: 1.9vw;
  /* margin: 0.6vw 0 0 1.9vw; */
  cursor: pointer;
}

.image-text_1 {
  width: 10.42vw;
  height: 1.67vw;
  margin: 0 0 0 37.55vw;
}

.label_6 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.6vw 0 0 0;
  cursor: pointer;
}

.text-group_1 {
  width: 3.13vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 0 0 0.88vw;
  cursor: pointer;
}

.text_5 {
  width: 1.72vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 0 0 0.88vw;
}

.text_6 {
  width: 3.13vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(160, 174, 188, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 0 0 0.88vw;
  cursor: pointer;
}

.label_7 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.6vw 0 0 1vw;
  cursor: pointer;
}

.label_8 {
  position: absolute;
  width: 1.67vw;
  height: 1.67vw;
  top: 0.6vw;
  right: 1.9vw;
  cursor: pointer;
}

.text-wrapper_3 {
  background-color: rgba(45, 46, 62, 1);
  width: 100vw;
  height: 2.87vw;
}

.text_7 {
  width: 7.3vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 0 0 1.87vw;
}

.text_8 {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.9vw 19.68vw 0 78.26vw;
}

.block_1 {
  width: 100vw;
  height: calc(100% - 2.87vw);
  margin-bottom: 0.06vw;
}

.box_1 {
  background-color: rgba(255, 255, 255, 1);
  width: 21.78vw;
  height: 100%;
}

.box_1_hidden {
  background-color: rgba(45, 46, 62, 1);
  width: 2.78vw;
  height: 100%;
}

.box_14 {
  position: relative;
  min-width: calc(100% - 24.65vw);
  width: auto;
  height: calc(100% - 2.8vw);
  margin-top: 0;
}

.editor {
  width: 100%;
  height: calc(100% - 2.14vw);
}

.editor-left {
  width: 100%;
  height: auto;
  min-height: 5.8vw;
}

.box_15 {
  background-color: rgba(255, 255, 255, 1);
  width: 21.78vw;
  height: 100%;
}

.box_15_hidden {
  background-color: rgba(45, 46, 62, 1);
  width: 2.78vw;
  height: 100%;
}

.py_result {
  margin-left: 1vw;
}

.group_5 {
  width: 6.41vw;
  height: 1.67vw;
  margin: 0.72vw 0 0 1.87vw;
}

.label_9 {
  width: 1.67vw;
  height: 1.67vw;
}

.text_9 {
  width: 4.17vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.3vw;
}

.group_6 {
  background-color: rgba(217, 217, 217, 0.5);
  width: 21.78vw;
  height: 0.11vw;
  margin-top: 0.47vw;
}

.text-wrapper_4 {
  background-color: rgba(255, 255, 255, 0.2);
  height: auto;
  margin-top: 0.16vw;
  width: 21.78vw;
}

.text_10 {
  width: 82%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: 800;
  text-align: left;
  line-height: 1.5vw;
  margin: 0.67vw 0 0 1.97vw;
  white-space: pre-wrap;
}

.text_11 {
  width: 82%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  line-height: 1.5vw;
  margin: 0.67vw 0 0 1.97vw;
  white-space: pre-wrap;
}

.text-wrapper_6 {
  background-color: rgba(255, 255, 255, 0.2);
  height: 2.71vw;
  width: 21.78vw;
}

.text_12 {
  width: 7.14vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.67vw 0 0 1.97vw;
}

.text-group_2 {
  width: 18.29vw;
  height: 13.86vw;
  margin: 0.41vw 0 0 2.03vw;
}

.text-wrapper_7 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  font-size: 0;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_13 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_14 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
}

.text_15 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_16 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(255, 71, 128, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
}

.text_17 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_18 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(255, 62, 122, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
}

.text_19 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_20 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(255, 62, 122, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
}

.text_21 {
  width: 18.29vw;
  height: 10.84vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
}

.text_22 {
  width: 3.13vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 1.67vw;
}

.box_2 {
  background-color: rgba(51, 51, 51, 1);
  border-radius: 0px 8px 0px 0px;
  width: 7.14vw;
  height: 45.42vw;
}

.box_3 {
  width: 5.47vw;
  height: 1.25vw;
  margin: 0.57vw 0 0 0.46vw;
}

.label_10 {
  width: 1.25vw;
  height: 1.25vw;
}

.text_24 {
  width: 3.75vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
}

.box_4 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 1.1vw;
}

.block_2 {
  background-color: rgba(251, 50, 112, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_25 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_5 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.box_6 {
  background-color: rgba(255, 173, 52, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_26 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_7 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.section_1 {
  background-color: rgba(81, 201, 161, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_27 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_8 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.group_7 {
  background-color: rgba(84, 107, 226, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_28 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_9 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.block_3 {
  background-color: rgba(119, 174, 67, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_29 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_10 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.block_4 {
  background-color: rgba(126, 190, 255, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_30 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_11 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.block_5 {
  background-color: rgba(204, 178, 255, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_31 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_12 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.group_8 {
  background-color: rgba(222, 79, 170, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_32 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.box_13 {
  width: 3.39vw;
  height: 1.62vw;
  margin-top: 0.53vw;
}

.block_6 {
  background-color: rgba(136, 129, 150, 1);
  width: 0.47vw;
  height: 1.62vw;
}

.text_33 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin-top: 0.21vw;
}

.text-wrapper_9 {
  width: 100%;
  height: 2.04vw;
  margin: 0;
}

.text_34 {
  width: 1.88vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.94vw;
  margin: 0.41vw 0 0 2.65vw;
}

.text-wrapper_10 {
  background-color: rgba(104, 162, 250, 1);
  height: 2.04vw;
  width: 7.14vw;
  cursor: pointer;
}

.text_35 {
  user-select: none;
  width: 7.14vw;
  height: 2.04vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 2.04vw;
  margin: 0;
}

.group_9 {
  position: relative;
  background-color: rgba(217, 217, 217, 0.2);
  width: 100%;
  height: 0.21vw;
}

.label_11 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 28.54vw 0 0 46.35vw;
}

.text-wrapper_11 {
  background-color: rgba(36, 38, 50, 1);
  height: 2.04vw;
  width: calc(100% - 7.14vw);
}

.text_36 {
  width: 18.03vw;
  height: 2.04vw;
  overflow-wrap: break-word;
  color: rgba(106, 184, 78, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2.04vw;
  margin-left: 1vw;
}

.label_13 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 30.2vw 0 0 45.41vw;
}

.label_14 {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.88vw 0 0 45.41vw;
}

.label_15 {
  width: 2.5vw;
  height: 2.5vw;
  margin: 1.4vw 0 1.19vw 45vw;
}

.block_7 {
  background-color: rgba(51, 51, 51, 0.8);
  border-radius: 8px 8px 0px 0px;
  /* left: 21.78vw;
    top: 2.87vw; */
  margin: 0;
  width: 8.44vw;
  height: 2.82vw;
}

.label_16 {
  width: 1.25vw;
  height: 1.25vw;
  margin: 0.75vw 0 0 0.83vw;
}

.text_37 {
  width: 6vw;
  height: 2.82vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 0.8);
  font-size: 0.93vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2.82vw;
  margin-left: 0.6vw;
}

.resize-handle {
  width: 4px;
  cursor: col-resize;
  background: #68a2fa;
  margin: 0 2px;
}

.resize-handle:active {
  user-select: none;
}

.step_img {
  width: 100%;
  height: auto;
}

.group_text {
  height: calc(100% - 3.1vw);
  overflow-y: auto;
}

.no-dot .dot-class {
  display: none;
}
</style>
